import HotelRoomMappingType from '@app/model/market_state/HotelRoomMappingType';
import MarketStateStatDateCompetitorLowestItem from '@app/model/market_state/MarketStateStatDateCompetitorLowestItem';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import AvailabilityIndex from '@app/model/market_state/AvailabilityIndex';

export class MarketStateStatDateCompetitorSnapshotLowestItemPerHotelIdAndRoomIds {
	hotelId: number;
	roomId: number;
	roomMappingType: HotelRoomMappingType;
	availability: number;
	availabilityIndex: AvailabilityIndex;
	isNotSupported: boolean;
	lowestItem: MarketStateStatDateCompetitorLowestItem;

	constructor(data: MarketStateStatDateCompetitorSnapshotLowestItemPerHotelIdAndRoomIds) {
		Object.assign(this, data);
	}

	public findRoomName(companyHotel: CompanyHotel) {
		return companyHotel.findHotelWithMappingsById(this.hotelId)?.roomMappings.find((rm) => rm.roomId == this.roomId)?.roomName || '';
	}

	public findHotelName(companyHotel: CompanyHotel) {
		return companyHotel.findHotelWithMappingsById(this.hotelId)?.hotel.name || '';
	}

	public hasAvailability() {
		return this.availability > 0;
	}

	public findRoom(companyHotel: CompanyHotel) {
		return companyHotel.findHotelWithMappingsById(this.hotelId)?.roomMappings.find((rm) => rm.roomId == this.roomId)??{
			roomName: '',
			roomMappingName: 'None',
			roomMappingType: HotelRoomMappingType.NONE,
			roomId: this.roomId
		};
	}

	public isAvailable() {
		return !!this.lowestItem && this.lowestItem.isAvailable;
	}

	public isSoldOut() {
		return !!this.lowestItem && this.lowestItem.isSoldOut;
	}

	public isLos() {
		return !!this.lowestItem && this.lowestItem.isLos;
	}

	public isSoldOutAndNotLos() {
		return !!this.lowestItem && this.lowestItem.isSoldOut && !this.lowestItem.isLos;
	}

	public isEmpty() {
		return !this.lowestItem || this.lowestItem.isEmpty;
	}

	public isNotAvailable() {
		return !this.lowestItem || this.lowestItem.isNotAvailable;
	}
}